module.exports = __webpack_public_path__ + "img/logo.3842c2ef.png";